module.exports = __webpack_public_path__ + "media/images/default/homepage/news/wave-9aa674a8487d5b99f1ae432599ddc946.svg";